import Photo1 from "../../../assets/bot-slider/s1.jpg";
import Photo2 from "../../../assets/bot-slider/s2.jpg";
import Photo3 from "../../../assets/bot-slider/s3.jpg";
import Photo4 from "../../../assets/bot-slider/s4.jpg";
import Photo5 from "../../../assets/bot-slider/s5.jpg";
import Photo6 from "../../../assets/bot-slider/s6.jpg";
import Photo7 from "../../../assets/bot-slider/s7.jpg";

export const Photos = [Photo1, Photo2, Photo3, Photo4, Photo5, Photo6, Photo7];
